import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare item has no pane of its own — land on the first tab.
export const Route = createFileRoute('/_app/dev-resources/transitions/one/item/')({
  beforeLoad: () => {
    throw redirect({ to: '/dev-resources/transitions/one/item/alpha' })
  },
})
